import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: 3,
    flexWrap: "wrap",
    gap: 2,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    mb: 0.5,
  },
  subtitle: {
    fontSize: "14px",
    color: color.lightText,
  },
  backButton: {
    borderRadius: "50px",
    textTransform: "none",
    px: 3,
    py: 1,
    fontWeight: 500,
  },
  summaryCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
    p: 3,
    mb: 3,
  },
  summaryLabel: {
    fontSize: "13px",
    color: color.lightText,
    mb: 0.5,
  },
  summaryValue: {
    fontSize: "28px",
    fontWeight: 600,
    color: color.text,
    lineHeight: 1.2,
  },
  summaryHint: {
    fontSize: "12px",
    color: color.lightText,
    mt: 0.5,
  },
  filterCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
    p: 2,
    mb: 3,
  },
  tableContainer: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  tableHeaderCell: {
    fontSize: { xs: "15px", md: "17px" },
    fontWeight: 500,
    lineHeight: 1.2,
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  tableCell: {
    fontSize: "14px",
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  emptyCell: {
    fontSize: "14px",
    color: color.lightText,
    py: 4,
  },
  statusChip: {
    fontSize: "12px",
    fontWeight: 500,
    height: "24px",
  },
  errorAlert: {
    mb: 2,
  },
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  resetButton: {
    textTransform: "none",
    fontWeight: 500,
  },
};

export default style;
